module.exports = __webpack_public_path__ + "img/credit-card (6).3aa4871b.svg";